import styled from 'styled-components';

// ---------------------------------------------------------------------------
// RH · Recrutamento — primitivos de layout de TELA DE DETALHE, compartilhados
// entre a ficha do candidato (CandidateShow), a da vaga (OpeningShow) e o
// onboarding (OnboardingShow). Promoção migrate-on-touch: extrair, não
// copiar/colar. Estilos específicos de cada tela ficam no styles.js dela.
//
// O HEADER é ON-DARK (redesign Claude Design 2026-07-14): o conteúdo das telas
// de detalhe senta direto no shell escuro, então título/sub/avatar usam a
// paleta clara do mock (cand-shell/cand.css) — não os tokens de texto do card.
// ---------------------------------------------------------------------------

const border = ({ theme }) => theme?.colors?.border ?? 'rgba(0,0,0,0.10)';
const muted = ({ theme }) => theme?.colors?.textMuted ?? '#6b7280';
const ink = ({ theme }) => theme?.colors?.textPrimary ?? '#1f1f18';

export const HeaderBar = styled.div`
   display: flex;
   align-items: flex-start;
   justify-content: space-between;
   gap: 16px;
   flex-wrap: wrap;
   margin-bottom: 20px;
`;

export const HeaderMain = styled.div`
   display: flex;
   align-items: center;
   gap: 16px;
   min-width: 0;
`;

export const Avatar = styled.div`
   flex-shrink: 0;
   width: 52px;
   height: 52px;
   border-radius: 50%;
   display: flex;
   align-items: center;
   justify-content: center;
   font-weight: 800;
   font-size: 16px;
   color: #cfe2fb;
   background: rgba(64, 152, 239, 0.25);
   border: 1px solid rgba(255, 255, 255, 0.16);
`;

export const TitleRow = styled.div`
   display: flex;
   align-items: center;
   gap: 12px;
   flex-wrap: wrap;

   h1 {
      margin: 0;
      font-size: 24px;
      font-weight: 700;
      line-height: 1.15;
      color: #fff;
   }
`;

export const MetaLine = styled.div`
   margin-top: 4px;
   display: flex;
   align-items: center;
   gap: 8px;
   flex-wrap: wrap;
   font-size: 13.5px;
   color: rgba(255, 255, 255, 0.62);

   .dot {
      opacity: 0.5;
   }

   b,
   strong {
      color: rgba(255, 255, 255, 0.88);
      font-weight: 600;
   }
`;

export const Card = styled.div`
   background: #fff;
   border: 1px solid ${border};
   border-radius: 14px;
   padding: 18px;
   margin-bottom: 16px;
`;

export const CardHead = styled.div`
   display: flex;
   align-items: center;
   justify-content: space-between;
   gap: 12px;
   margin-bottom: 14px;

   h2 {
      margin: 0;
      font-size: 1rem;
      font-weight: 800;
      color: ${ink};
   }
`;

export const FactGrid = styled.div`
   display: grid;
   grid-template-columns: repeat(auto-fit, minmax(190px, 1fr));
   gap: 12px 18px;
`;

export const Fact = styled.div`
   min-width: 0;

   .fact-label {
      font-size: 11px;
      font-weight: 700;
      text-transform: uppercase;
      letter-spacing: 0.03em;
      color: ${muted};
   }
   .fact-value {
      margin-top: 2px;
      font-size: 0.9rem;
      font-weight: 600;
      color: ${ink};
      word-break: break-word;
   }
   .fact-value.muted {
      font-weight: 500;
      color: ${muted};
   }
`;

export const InlineHint = styled.p`
   margin: 0;
   font-size: 0.86rem;
   color: ${muted};
`;

export const BackRow = styled.div`
   margin-bottom: 14px;
`;
